"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataBoundItem = void 0;
const property_helper_1 = require("../property-helper/property-helper");
class DataBoundItem {
    constructor(Data) {
        this.label = Data.toString();
        this.value = Data;
        this.originalValue = Data;
    }
    static InitList(Items) {
        const newList = new Array();
        Items.forEach((r) => {
            const item = new DataBoundItem(r);
            newList.push(item);
        });
        return newList;
    }
    static IsObjectList(Items) {
        const cast = Items.find((r) => true);
        return typeof cast === 'object';
    }
    loadValueToProperty(property, parentValueAccessor, reload = false) {
        if (this[property] === undefined || reload) {
            if (this.valueAccessor) {
                this[property] = property_helper_1.PropertyHelper.ReduceProperty(this.originalValue, this.valueAccessor);
            }
            else if (parentValueAccessor) {
                this[property] = property_helper_1.PropertyHelper.ReduceProperty(this.originalValue, parentValueAccessor);
            }
        }
    }
    loadValue(parentValueAccessor, reload = false) {
        this.loadValueToProperty('value', parentValueAccessor, reload);
    }
    updateValueToProperty(Value, Property) {
        property_helper_1.PropertyHelper.SetProperty(this.originalValue, Property, Value);
    }
    updateValue(Value, ParentValueAccessor) {
        if (this.valueAccessor) {
            this.updateValueToProperty(Value, this.valueAccessor);
        }
        else if (ParentValueAccessor) {
            this.updateValueToProperty(Value, ParentValueAccessor);
        }
        this.loadValue(ParentValueAccessor, true);
    }
    loadLabel(parentLabelAccessor, reload = false) {
        this.loadValueToProperty('label', parentLabelAccessor, reload);
    }
}
exports.DataBoundItem = DataBoundItem;
//# sourceMappingURL=data-bound-item.utils.js.map